import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
import { getAccessToken } from '../utils/getAccessToken'; // Load worker code separately with worker-loader

class MapboxService {
  constructor() {
    this.mapbox = null;
    this.mapboxgl = null;
  }
}

let mapIns = null;

export const getMapboxgl = () => {
  if (!mapIns) {
    mapIns = new MapboxService();
    try {
      mapIns.mapboxgl = mapboxgl;
      mapIns.mapboxgl.workerClass = MapboxWorker; // Wire up loaded worker to be used instead of the defaultimport { getAccessToken } from '../utils/getAccessToken';
      mapIns.mapboxgl.accessToken = getAccessToken();
      if (!mapIns.mapboxgl.supported()) {
        alert('Your browser does not support Mapbox GL');
      }
    } catch (e) {
      throw e;
    }
  }
  return mapIns;
};

export const clearMapboxgl = () => {
  mapIns = null;
};
